'use client';

import { forwardRef, useContext, useMemo } from 'react';

import { css, cx } from '@/styled-system/css';

import { Spinner } from '../spinner/spinner';
import { ToggleButtonRootContext } from './context/toggle-button-root.context';
import { toggleButtonLoadingStyles } from './styles/toggle-button-loading.styles';
import type { ToggleButtonLoadingPropsInterface } from './types/toggle-button-loading.types';

/**
 * @since 10.0.0
 */
export const ToggleButtonLoading = forwardRef<HTMLSpanElement, ToggleButtonLoadingPropsInterface>(
  (props, forwardedRef) => {
    const { size = 'md' } = useContext(ToggleButtonRootContext);
    const { className } = props;

    const styles = css(toggleButtonLoadingStyles);

    const spinnerSize = useMemo(() => {
      return size === 'sm' ? 'sm' : 'md';
    }, [size]);

    return (
      <span
        ref={forwardedRef}
        data-c11n-component="ToggleButton.Loading"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'group', styles, className)}
      >
        <Spinner size={spinnerSize} />
      </span>
    );
  },
);

ToggleButtonLoading.displayName = 'ToggleButton.Loading';
